var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCms(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 185,
    viewBox: "0 0 185 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2396_1428)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2396_1428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.959 67.6468C132.774 63.0196 125.784 60.706 115.644 60.706H114.462V60.509C114.462 52.239 114.462 42 95.9531 42H88.4708C69.9617 42 69.9617 52.2883 69.9617 60.509V60.7552H68.7803C58.5905 60.7552 51.6496 63.0688 47.4653 67.6961C42.592 73.1109 42.7396 80.3964 43.2319 85.3683L43.2811 85.7128L43.7734 90.8816C43.7734 90.8816 47.3177 93.2445 49.0898 94.229C49.779 94.672 50.5174 95.0658 51.2558 95.4596C59.6734 100.087 68.928 103.188 78.3302 104.714C78.7732 109.341 80.7915 114.756 91.572 114.756C102.353 114.756 104.469 109.391 104.814 104.616C114.856 102.991 124.554 99.4962 133.316 94.3767C133.611 94.229 133.808 94.0813 134.054 93.9336C136.319 92.6537 138.681 91.0293 140.749 89.5033L140.946 87.7311L141.192 85.4175C141.241 85.1221 141.241 84.876 141.29 84.5314C141.684 79.5596 141.586 72.7664 136.959 67.6468ZM97.5776 101.367C97.5776 106.585 97.5776 107.372 91.5228 107.372C85.468 107.372 85.468 106.437 85.468 101.416V95.2135H97.5776V101.367ZM77.0011 60.706V60.509C77.0011 52.1406 77.0011 49.0393 88.4708 49.0393H95.9531C107.423 49.0393 107.423 52.1898 107.423 60.509V60.7552H77.0011V60.706Z",
    fill: "url(#paint0_linear_2396_1428)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.866 98.9692L137.7 122.829C136.666 132.674 132.629 142.716 110.97 142.716H73.4594C51.7999 142.716 47.7634 132.674 46.7296 122.878L44.6621 100.136C44.6621 100.136 63.565 109.095 72.2288 110.965C74.9362 118.152 81.631 121.992 91.5747 121.992C101.42 121.992 108.213 118.005 110.921 110.818C120.077 108.849 139.866 98.9692 139.866 98.9692Z",
    fill: "url(#paint1_linear_2396_1428)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2396_1428",
    x: 13.6764,
    y: 35.6764,
    width: 157.083,
    height: 159.363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 23
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.6618
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.156863 0 0 0 0 0.945098 0 0 0 0 0.28298 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2396_1428"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2396_1428",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0851667 0 0 0 0 0.608333 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2396_1428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2396_1428",
    x1: 34.0018,
    y1: 42,
    x2: 122.977,
    y2: 164.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06EE1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2396_1428",
    x1: 35.9594,
    y1: 98.9692,
    x2: 78.1659,
    y2: 192.408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06EE1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2396_1428"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 185,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCms);
export default __webpack_public_path__ + "static/media/iconCMS.9f80579e7262268744aa9a1f9eccfe7d.svg";
export { ForwardRef as ReactComponent };